module.exports = {
      id: "gzsports-usage",
      viewBox: "0 0 17.95 23.898",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#gzsports",
      toString: function () {
        return this.url;
      }
    }